import React from 'react';
import { useLocalization } from '@microsoft/portal-app/lib/shared/localization';
import { DefaultButton, PrimaryButton } from '@fluentui/react';
import { Dialog, DialogFooter, IDialogProps } from '@fluentui/react/lib/Dialog';

interface IDeclinePopupProps extends IDialogProps {
  tenantDisplayName: string;
  onDismiss: () => void;
  onConfirm: () => void;
}

export const DeclinePopup: React.FC<IDeclinePopupProps> = (props) => {
  const { tenantDisplayName, onDismiss, onConfirm } = props;

  const [t] = useLocalization('TermsOfUse');
  const dialogContentProps = {
    ...props.dialogContentProps,
    title: t('declinePopupHeader'),
    subText: t('declinePopupBody', { orgName: tenantDisplayName }),
  };
  const modalProps = { ...props.modalProps, isBlocking: true };
  return (
    <Dialog dialogContentProps={dialogContentProps} modalProps={modalProps} {...props}>
      <DialogFooter>
        <DefaultButton text={t('declinePopupBackButtonText')} onClick={onDismiss} />
        <PrimaryButton text={t('declinePopupDeclineButtonText')} onClick={onConfirm} />
      </DialogFooter>
    </Dialog>
  );
};
